module.exports = __webpack_public_path__ + "static/5-c4f91bbdae0ba759b2dd330ed63db511.jpg";